export default __webpack_public_path__ + "static/media/home-icon-active.6948c6a9.webp";